import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorId}/creatorBillingInvoice.csv']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];

const getCreatorBillingInvoiceCsv = async ({ creatorId, invoiceId }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/creators/${creatorId}/creatorBillingInvoice.csv`, {
    params: {
      invoiceId,
    },
  });
  return response.data;
};

export default getCreatorBillingInvoiceCsv;